/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import ReferralRewardsModal from '../ReferralRewardsModal/ReferralRewardsModal';
import {
  connectModalContainerContextToComponent,
} from '../../../contexts/ModalContext/ModalContext';

/* istanbul ignore next */
function ReferralsInfoBlurb({ setModalJSX }) {
  return (
    <div className="alert alert-info rounded my-1">
      Recommending Room Alert to a colleague or friend? If they use your referral code on their next order, they&apos;ll save and you&apos;ll earn!
      {' '}
      <button
        type="button"
        className="btn btn-link p-0 pb-1"
        onClick={() => {
          setModalJSX(
            <ReferralRewardsModal />,
          );
        }}
      >
        Referral Discounts & Rewards
      </button>
    </div>
  );
}

ReferralsInfoBlurb.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
};

export { ReferralsInfoBlurb };
export default connectModalContainerContextToComponent(ReferralsInfoBlurb);
